const TEXT_BOX_COLORS = [
  {
    card: 'border-sky-200 bg-sky-50/70 hover:border-sky-300 hover:bg-sky-50',
    badge: 'bg-sky-100 text-sky-800',
    field: 'border-sky-200 bg-white focus:border-sky-500',
  },
  {
    card: 'border-violet-200 bg-violet-50/70 hover:border-violet-300 hover:bg-violet-50',
    badge: 'bg-violet-100 text-violet-800',
    field: 'border-violet-200 bg-white focus:border-violet-500',
  },
  {
    card: 'border-amber-200 bg-amber-50/70 hover:border-amber-300 hover:bg-amber-50',
    badge: 'bg-amber-100 text-amber-800',
    field: 'border-amber-200 bg-white focus:border-amber-500',
  },
  {
    card: 'border-rose-200 bg-rose-50/70 hover:border-rose-300 hover:bg-rose-50',
    badge: 'bg-rose-100 text-rose-800',
    field: 'border-rose-200 bg-white focus:border-rose-500',
  },
  {
    card: 'border-teal-200 bg-teal-50/70 hover:border-teal-300 hover:bg-teal-50',
    badge: 'bg-teal-100 text-teal-800',
    field: 'border-teal-200 bg-white focus:border-teal-500',
  },
  {
    card: 'border-lime-200 bg-lime-50/70 hover:border-lime-300 hover:bg-lime-50',
    badge: 'bg-lime-100 text-lime-800',
    field: 'border-lime-200 bg-white focus:border-lime-500',
  },
];

export const getTextBoxColor = (index) => (
  index < 0
    ? { card: 'border-slate-200 bg-white', badge: 'bg-slate-100 text-slate-700', field: 'border-slate-200 bg-slate-50/50 focus:border-slate-400' }
    : TEXT_BOX_COLORS[index % TEXT_BOX_COLORS.length]
);
